import React from "react";
import { View, StyleSheet } from "react-native";
import { layout } from "@/constants";
import NotificationCard from "./base/NotificationCard";

/**
 * Props for the ChatErrorsDisplay component
 */
interface ChatErrorsDisplayProps {
  /** Error message */
  error: string | null;
}

/**
 * Component that displays chat room errors
 * Shows error messages with consistent styling
 */
export default function ChatErrorsDisplay({ error }: ChatErrorsDisplayProps) {
  // Don't render anything if there are no errors
  if (!error) {
    return null;
  }

  return (
    <View style={styles.container}>
      <NotificationCard variant="error" label="Error" message={error} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: layout.space.lg,
    paddingVertical: layout.space.sm
  }
});
